import { render } from "./SupportView.vue?vue&type=template&id=5afbbc8a"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5afbbc8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5afbbc8a', script)) {
    api.reload('5afbbc8a', script)
  }
  
  module.hot.accept("./SupportView.vue?vue&type=template&id=5afbbc8a", () => {
    api.rerender('5afbbc8a', render)
  })

}

script.__file = "src/views/support/SupportView.vue"

export default script